// Este archivo contiene una colección de frases divertidas relacionadas con la maternidad
// que se muestran en la página de error 404.
// Las frases tienen un tono amigable y humorístico, haciendo referencia a situaciones
// cotidianas de las madres, como buscar objetos perdidos o lidiar con múltiples tareas.
// Este toque personal y cercano ayuda a suavizar la experiencia de encontrar una página
// que no existe

const phrases = [
  "¿Perdido? No, esto solo está escondido. Dame un segundo y lo encontraré... ¡Como todo lo que desaparece en esta casa!",
  "Esto está más perdido que mis ganas de escuchar 'es que no lo encuentro' por enésima vez. Pero tranquila, ¡yo lo encuentro por ti!",
  "¿Que no lo ves? Es porque no has usado el modo 'mamá multitarea', que incluye radar integrado para encontrar lo perdido.",
  "Esto está más perdido que mi sueño de dormir ocho horas seguidas. Pero tranquila, ¡yo lo rescato! Porque las mamás somos expertas en hacer milagros.",
  "Las mamás somos como Sherlock Holmes, pero con superpoderes adicionales. Déjame encontrar eso por ti... mientras resuelvo otros 5 problemas.",
  "Las mamás siempre nos ayudamos unas a otras. ¿No encuentras algo? ¡Yo te echo una mano! Porque juntas somos imparables.",
  "¿Que no lo ves? No te preocupes, las mamás somos un equipo. ¡Juntas lo encontramos y todavía nos queda tiempo para un café!",
  "Las mamás no competimos, nos apoyamos. ¿Algo perdido? ¡Aquí estoy yo para ayudarte a encontrarlo!",
  "Las mamás somos como magas: encontramos lo imposible, resolvemos lo irresoluble y todavía tenemos tiempo para un café (frío, pero café).",
  "Esto está más perdido que el concepto de 'descanso' en la vida de una mamá. Pero tranquila, ¡yo lo encuentro en un abrir y cerrar de ojos!",
];

export default phrases;
